import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface GenerateInputSchemaFromExampleResponse {
  schema: string;
}

export function useGenerateInputSchemaFromExample() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async ({
      agentUuid,
      exampleSchema,
    }: {
      agentUuid: string;
      exampleSchema: string;
    }): Promise<GenerateInputSchemaFromExampleResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/generate_input_schema_from_example`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ agentUuid, exampleSchema }),
        }
      );

      const data = await response.json();

      return {
        schema: data?.data?.schema,
      };
    },
  });
}
